/*
 * Chips de filtro rápido da coleção (snippets/collection-quick-filters.liquid).
 *
 * O href de cada chip já é um link válido — serve de fallback e para o
 * crawler. O clique, porém, é interceptado aqui para preservar os outros
 * filtros/ordenação que estiverem ativos e reaproveitar o mesmo AJAX dos
 * filtros nativos (CollectionFiltersForm.renderPage), em vez de recarregar
 * a página inteira.
 *
 * Estado ativo não é calculado aqui: os chips ficam dentro de `.collection`,
 * que o collection-filters-form.js re-renderiza a partir do servidor.
 */
class QuickFilters extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-quick-chip]');
      if (!chip || !this.contains(chip)) return;

      event.preventDefault();
      this.toggle(chip);
    });
  }

  /* Aciona o item correspondente no "Organizar por". Devolve false quando a
     opção não existe na toolbar. */
  clickToolbarSort(value) {
    if (!value) return false;

    const option = document.querySelector('[data-sorting] [data-sort-by-item] .text[data-value="' + value + '"]');
    const item = option ? option.closest('[data-sort-by-item]') : null;
    if (!item) return false;

    item.click();
    return true;
  }

  toggle(chip) {
    const params = new URLSearchParams(window.location.search);
    const active = chip.classList.contains('is-active');
    const value = chip.dataset.quickValue;

    if (chip.dataset.quickType === 'path') {
      /* Chip de tag no modo link nativo (/collections/handle/tag): a tag vive
         no caminho, não na query string, e o renderPage dos filtros só troca a
         query (o pathname dele é sempre o atual). Então aqui é navegação mesmo
         — levando junto os filtros e a ordenação que já estavam na URL. */
      params.delete('page');

      const search = params.toString();
      window.location.href = chip.getAttribute('href') + (search ? '?' + search : '');
      return;
    }

    if (chip.dataset.quickType === 'sort') {
      /* Ligando: quem manda na ordenação é a toolbar. Repassar o clique
         mantém o "Organizar por" coerente com o chip e reaproveita o AJAX
         do tema. */
      if (!active && this.clickToolbarSort(value)) return;

      /* Desligando (ou sem a opção na toolbar): tira o sort_by da URL para
         voltar à ordenação padrão da coleção e recarrega a página. Mais lento
         que o AJAX, mas é o único jeito de o rótulo da toolbar não ficar
         mostrando a ordenação antiga. */
      if (active) params.delete('sort_by');
      else params.set('sort_by', value);
      params.delete('page');

      const url = params.toString();
      window.location.href = window.location.pathname + (url ? '?' + url : '');
      return;
    } else {
      const key = chip.dataset.quickKey;

      if (chip.dataset.quickMulti === 'true') {
        /* Filtros de tag aceitam vários valores ao mesmo tempo, então só o
           valor deste chip pode sair — os outros continuam. O Shopify aceita
           tanto `tag=a&tag=b` (o que os checkboxes da sidebar geram) quanto
           `tag=a,b`, então normaliza os dois antes de mexer. */
        const values = params
          .getAll(key)
          .reduce((all, item) => all.concat(item.split(',')), [])
          .map((item) => item.trim())
          .filter((item) => item && item !== value);

        if (!active) values.push(value);

        params.delete(key);
        values.forEach((item) => params.append(key, item));
      } else if (active) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    }

    /* Trocar de filtro sempre volta para a primeira página. */
    params.delete('page');

    const search = params.toString();

    if (typeof CollectionFiltersForm !== 'undefined' && document.querySelector('collection-filters-form')) {
      CollectionFiltersForm.renderPage(search);
    } else {
      window.location.href = window.location.pathname + (search ? '?' + search : '');
    }
  }
}

if (!customElements.get('quick-filters')) {
  customElements.define('quick-filters', QuickFilters);
}
